/**
 * Class responsible for handling quantity changes in product cards.
 * It updates UI elements such as the purchase button and stock warnings
 * based on user interactions with the quantity input inside a shadow DOM.
 */
class QuantityProductCardInterceptor {
  constructor() {
    this.quantityContent = document.querySelectorAll('[id^="CardProduct-"]');
    this.cardShadowRoot = null;
    this.inputQuantity = null;
    this.buttonPurchase = null;
    this.inventoryQuantity = 0;
    this.snippet = null;
  }

  /**
   * Initializes event listeners on each product card to handle quantity logic.
   */
  init() {
    if (this.quantityContent.length === 0) return;

    this.quantityContent.forEach((card) => {
      card.addEventListener(
        "click",
        (e) => {
          const targetCard = e.target;

          this.snippet =
            targetCard.parentElement.querySelector("#snippet-container");

          if (!this.snippet) {
            console.error("Snippet container not found");
            return;
          }

          const inputStock = targetCard.parentElement.querySelector(
            "input[name='inventory_quantity']"
          );
          if (!inputStock) {
            console.error("Input stock not found");
            return;
          }

          this.inventoryQuantity = inputStock.value;
          this.cardShadowRoot = targetCard.shadowRoot;
          this.#handleQuantityInput();
        },
        true
      );
    });
  }

  /**
   * Private method that handles quantity input and binds button click listeners.
   * Validates and updates the UI based on current quantity input.
   * @private
   */
  #handleQuantityInput() {
    const quantityContainer = this.cardShadowRoot.querySelector(
      "div.quantity-selector-wrapper "
    );
    const selectorVariant = this.cardShadowRoot.querySelector(
      ".product-variant-select select"
    );

    if (!quantityContainer || !selectorVariant) {
      console.error("Quantity or selector container not found");
      return;
    }

    const buttons = quantityContainer.querySelectorAll("button");
    if (!buttons && buttons.length < 2) {
      console.error("Buttons not found");
      return;
    }
    const minusButton = buttons[0];
    const plusButton = buttons[1];

    this.inputQuantity = quantityContainer.querySelector("input");
    if (!this.inputQuantity) {
      console.error("Input field not found");
      return;
    }

    this.buttonPurchase =
      quantityContainer.parentElement.parentElement.querySelector(
        ".button-purchase button"
      );

    if (!this.buttonPurchase) {
      console.error("Purchase button not found");
      return;
    }

    minusButton.addEventListener("click", () => {
      setTimeout(this.#updateState(), 10);
    });
    plusButton.addEventListener("click", () => {
      setTimeout(this.#updateState(), 10);
    });

    selectorVariant.addEventListener("change", () => {
      setTimeout(this.#updateState(), 10);
    });
  }

  /**
   * Private method to update the UI state based on the current quantity value.
   * Enables or disables the purchase button and shows/hides warnings.
   * @private
   */
  #updateState() {
    const currentValue = parseInt(this.inputQuantity?.value || "0", 10) || 0;

    const outOfStock = this.cardShadowRoot.querySelector("p.out-of-stock");

    if (outOfStock) {
      if (this.snippet) this.snippet.classList.remove("hidden");
      if (this.buttonPurchase)
        this.buttonPurchase.setAttribute("disabled", true);
      return;
    }

    if (currentValue <= 0 || currentValue > this.inventoryQuantity) {
      if (!this.snippet) return;
      if (currentValue !== 0) this.snippet.classList.remove("hidden");
      this.buttonPurchase.setAttribute("disabled", true);
    } else {
      this.snippet.classList.add("hidden");
      this.buttonPurchase.removeAttribute("disabled");
    }
  }
}
